<template>
    <div class="mediaMain">
        <loader v-if="mediaLoading"/>
        <h4>File Search Reports</h4>
        <div>
            <div v-if="fileSearchComplete && mediaGridSpec.tableData.length < 1" class="alert alert-info alert-dismissible" role="alert">
                File Search Reports are being generated.
            </div>
            <v-client-table v-show="!fileSearchComplete || mediaGridSpec.tableData.length > 0" :data="mediaGridSpec.tableData" :columns="mediaGridSpec.columns" :options="mediaGridSpec.options">
                <template slot="download" slot-scope="props">
                    <div style="text-align: center;">
                        <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.parentId, props.row.filename)"></a>
                    </div>
                </template>
            </v-client-table>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import mediaService from '../services/mediaService'
import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    name: 'media',
    props: {
        parentId: { required: true },
        loadOnMount: { default: true },
        fileSearchComplete: { default: false }
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            serverErrorList: [],
            mediaGridSpec: {
                columns: ['download', 'filename', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        filename: 'Filename',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    computed: {
        componentName: function () {
            return 'MediaFileSearchReport ' + this._uid
        },
        mediaTypeId: function () {
            return mediaService.mediaType.FileSearchReport
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted ' + this._uid)
        loggingService.log(this.isDebug, this.componentName, 'mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

        if (this.loadOnMount) this.loadMedia()
    },
    methods: {
        loadMedia () {
            loggingService.log(this.isDebug, this.componentName, 'loadMedia, mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

            if (this.mediaTypeId && this.parentId) {
                this.mediaLoading = true

                var handle = this
                mediaService.list(this.$http, this.mediaTypeId, null, this.parentId).then(function (response) {
                    handle.mediaGridSpec.tableData = response.data
                    handle.mediaLoading = false
                })
            }
        },
        mediaDownloadRow (mediaId, mediaTypeId, parentId, filename) {
            loggingService.log(this.isDebug, 'FileSearchReport', 'mediaDownloadRow - mediaId: ' + mediaId + ', mediaTypeId: ' + mediaTypeId + ', parentId: ' + parentId)

            mediaService.get(this.$http, mediaId, mediaTypeId, null, parentId).then(function (response) {
                mediaService.saveFileToDownload(response, filename)
            })
        }
    }
}
</script>



<style>
    .mediaMain {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 5px;
        background-color: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// MediaFileSearchReport.vue?b72882e2